"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = isEmpty;
function isEmpty(obj) {
    return obj && Object.keys(obj).length === 0;
}
//# sourceMappingURL=object.js.map